module.exports = __webpack_public_path__ + "assets/img/home_cs_7.ecfa34ff.png";